var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1092_31169)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1092_31169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.091 7.67897L12.2737 7.15964C11.4553 6.92891 10.7098 6.49202 10.1085 5.89077C9.50728 5.28952 9.07039 4.54403 8.83967 3.72564L8.32033 1.9083C8.29421 1.84472 8.24978 1.79034 8.19269 1.75207C8.13559 1.71379 8.0684 1.69336 7.99967 1.69336C7.93093 1.69336 7.86374 1.71379 7.80664 1.75207C7.74955 1.79034 7.70512 1.84472 7.679 1.9083L7.15967 3.72564C6.92894 4.54403 6.49205 5.28952 5.8908 5.89077C5.28955 6.49202 4.54406 6.92891 3.72567 7.15964L1.90833 7.67897C1.83855 7.69878 1.77714 7.7408 1.73341 7.79867C1.68968 7.85655 1.66602 7.9271 1.66602 7.99964C1.66602 8.07217 1.68968 8.14273 1.73341 8.2006C1.77714 8.25847 1.83855 8.3005 1.90833 8.3203L3.72567 8.83964C4.54406 9.07037 5.28955 9.50726 5.8908 10.1085C6.49205 10.7098 6.92894 11.4552 7.15967 12.2736L7.679 14.091C7.6988 14.1608 7.74083 14.2222 7.7987 14.2659C7.85657 14.3096 7.92713 14.3333 7.99967 14.3333C8.0722 14.3333 8.14276 14.3096 8.20063 14.2659C8.2585 14.2222 8.30053 14.1608 8.32033 14.091L8.83967 12.2736C9.07039 11.4552 9.50728 10.7098 10.1085 10.1085C10.7098 9.50726 11.4553 9.07037 12.2737 8.83964L14.091 8.3203C14.1608 8.3005 14.2222 8.25847 14.2659 8.2006C14.3097 8.14273 14.3333 8.07217 14.3333 7.99964C14.3333 7.9271 14.3097 7.85655 14.2659 7.79867C14.2222 7.7408 14.1608 7.69878 14.091 7.67897Z",
    fill: "url(#paint0_linear_1092_31169)",
    fillOpacity: 0.56
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1092_31169",
    x: -0.333984,
    y: 0.693359,
    width: 16.667,
    height: 16.6396,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.392157 0 0 0 0 0.219608 0 0 0 0 0.960784 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1092_31169"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1092_31169",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1092_31169",
    x1: 0.846211,
    y1: 12.242,
    x2: 15.6078,
    y2: 12.5145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A36BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#672F94"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1092_31169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailStar);
export default __webpack_public_path__ + "static/media/emailStar.659f9742a9f8e79263d24c018523d4e8.svg";
export { ForwardRef as ReactComponent };